import { render, staticRenderFns } from "./CreateDataset.vue?vue&type=template&id=8a40133c&"
import script from "./CreateDataset.vue?vue&type=script&lang=js&"
export * from "./CreateDataset.vue?vue&type=script&lang=js&"
import style0 from "./CreateDataset.vue?vue&type=style&index=0&id=8a40133c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports